<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient3 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(0, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(0, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(0, 0, 0, 0)");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 1)");

    this.gradient3.addColorStop(0, "rgba(0, 231, 144, 0.9)");
    this.gradient3.addColorStop(0.5, "rgba(0, 231, 144, 0.25)");
    this.gradient3.addColorStop(1, "rgba(0, 231, 144, 1)");

    this.renderChart(
      {
        labels: [
          ["Б/У трубная", "продукция"],
          "Б/у НКТ",
          ["Б/у штанги", "насосные"],
          ["Стальной", "кусковой лом,", "отходы"],
          ["Прочий лом", "Черный", "металлолом"],
          ["Алюминий", "провод АС"],
          ["Аккумуляторные", "батареи"],
          "Медь",
          ["Кабельная", "линия, провод"],
          ["Прочий лом", "Цветной", "металлолом"],
        ],
        datasets: [
          {
            label: "Остаток на начало месяца",
            // backgroundColor: "#f87979",
            backgroundColor: this.gradient,
            // data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
            data: this.$parent.getData('count_before'),
          },
          {
            label: "Прибыло",
            backgroundColor: this.gradient2,
            data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
          },
          {
            label: "Реализовано",
            backgroundColor: this.gradient3,
            data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
          },
          {
            label: "Остаток на конец месяца",
            backgroundColor: this.gradient2,
            data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      }
    );
  },
};
</script>
